/**
 * @file app.js
 * @description This file contains the default variables.
 * @version 0.0.1
 * Created at: 11/08/2025
 * Updated at: 11/08/2025
 */
/**
 * Application name
 * @type {string}
 */
export const APP_NAME = 'London Business School';
export const APP_DESCRIPTION =
  "We deliver postgraduate business education offering one of the world's best MBA programmes, Masters and PhD degrees, plus short courses for executives.";

export const APP_NAME_SLUG = `${APP_NAME?.slice(0, 5).replaceAll(' ', '-').toLowerCase()}`;

// If callback url not exsit in URL then after signin the user will redirect on this route
export const DEFAULT_REDIRECTION = '/dashboard';

// All protected must start with this route
export const PROTECTED_ROUTE_STARTWITH = '/dashboard';

// Public paths for application
export const PUBLIC_ROUTES = [
  '/login',
  '/sign-up',
  '/forgot-password',
  '/invitation/accept',
  '/invitation/decline',
  '/theme'
];

/**
 * Revalidate time(s) each fetch request
 * Set default revalidate at every hour
 */
export const REVALIDATE_TIME = 60;

/**
 * Local storage key prefix
 * @type {string}
 */
export const LOCAL_STORAGE_PREFIX = APP_NAME_SLUG;

/**
 * Configure local-storage
 */
export const localStorageConfig = {
  version: 1,
  expiry: 24 * 60 * 60 * 1000, // 24 hour
  encrypt: true,
};

/**
 * Configure Toast
 */
export const ToastConfig = {
  position: 'top-right',
  offset: '16px',
  richColors: true,
  toastOptions: {
    // Define default options
    className: '',
    duration: 3000,
  },

  icons: {
    // Define custom icons
    // success: ,
    // info: ,
    // warning: ,
    // error: ,
    // loading:
  },
};

/**
 * Console log colors
 */
export const BOLD = '\x1b[1m';
export const RED = '\x1b[31m';
export const GREEN = '\x1b[32m';
export const RESET = '\x1b[0m';

// /**
//  * Role based routes access
//  */
// export const ROLE_BASED_ROUTES = {
//   manager: [
//     '/manager/roleplay-and-courses',
//     '/manager/org-users',
//     '/manager/user-groups',
//     '/manager/profile',
//     '/manager/roleplay',
//   ],
//   admin: ['/user/home', '/user/preview', '/user/reports', '/user/session'],
//   user: ['/user/home', '/user/preview', '/user/reports', '/user/session'],
// };

export const ROLE_ROUTE_ACCESS = {
  'super-admin': ['/dashboard'],
  admin: ['/manager'],
  manager: ['/manager'],
  user: ['/user'],
};

export const SUPPORT_EMAIL = 'vikas.patel@imeld.ai';
